import React from 'react';
import ReactDOM from 'react-dom';
import { Snackbar, Alert } from '@mui/material';

const AlertPortal = ({ open, message, severity, onClose }) => {
    return ReactDOM.createPortal(
        <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>,
        document.body
    );
};

export default AlertPortal;